import React, { useState } from 'react'
import { Fetch } from '../../services/api'
import { notify, urlApiPlamin } from '../../utils/utils'

export const useSeguimientoIncidencias = () => {

  const [seguimientosPorFecha, setSeguimientosPorFecha] = useState([])
  const [empresas, setEmpresas] = useState([])
  
  const listarEmpresas = async () => {
    const response = await Fetch({
      url: 'https://empresa.api.abexacloud.com/api/Empresa/listaEmpresa'
    })

    if(response.isValid){
      setEmpresas(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }
  
  const listarSeguimientosPorFecha = async (fechaInicio, fechaFin, codEmpresa) => {
    const response = await Fetch({
      url: urlApiPlamin + '/seguimientosPorFecha?' + new URLSearchParams({
        FechaInicio: fechaInicio,
        FechaFin: fechaFin,
        CodEmpresa: codEmpresa
      })
    })

    if(response.isValid){
      setSeguimientosPorFecha(response.content)
    }else{
      notify(response.exceptions[0].description, 'error')
    }
  }
  
  return {
    listarEmpresas,
    empresas,
    listarSeguimientosPorFecha, 
    seguimientosPorFecha
  }
}
